import "./tarifsDetails.css";

import TarifsDetailsContenair from "./tarifsDetailsContenair";

function TarifsDetails() {
  return (
    <div className="tarifs-details-main">
      <div className="tarifs-details-title">
        <h1>DÉTAILS DES PRESTATIONS</h1>
      </div>
      <TarifsDetailsContenair />
    </div>
  );
}

export default TarifsDetails;
